import { useBackend } from "../../services";
import { FilterElement } from "../../models/FilterElement";
import { ShelfSegmentAlbumShape } from "./interfaces";
import { IIsNegatedAlbumsParameters } from "../albums";

export const useAssignAlbumsToShelfSegmentByFilter = () => {
  const { post } = useBackend();
  const assignAlbumsToShelfSegmentByFilter = (
    parameters: IAssignAlbumsToShelfSegmentByFilterParameters,
    filterElements: FilterElement[]
  ) => {
    const filters = FilterElement.queryItems(filterElements);
    if (!filters) return;
    return post("shelfSegments/albums/filter", { ...parameters, ...filters });
  };
  return { assignAlbumsToShelfSegmentByFilter };
};

export interface IAssignAlbumsToShelfSegmentByFilterParameters {
  assignToShelfSegmentId: string;
  order: number;
  shape: ShelfSegmentAlbumShape;
  removeFromPreviousLocations: boolean;
  collectionId: string | undefined;
  isNegated: IIsNegatedAlbumsParameters;
}
